
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        nama: "",
        fasilitas: "",
        kecamatan: "",
        des_kel: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        tanggal: null,
        status: "",
        deskripsi: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;

      const id = this.form?.indikator?.id;

      if (id == 29) {
        percentage =
          totals.a > 0 ? ((totals.b / totals.a) * 100).toFixed(2) : 0;
      } else if (id == 12) {
        percentage =
          totals.c > 0
            ? (((totals.a + totals.b) / totals.c) * 100).toFixed(2)
            : 0;
      } else if (id == 10) {
        const numerator = totals.a + totals.b + totals.c;
        const denominator = totals.d + totals.e + totals.f;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else if (id == 4) {
        const numerator = totals.c + totals.d;
        const denominator = totals.a + totals.b;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else {
        percentage =
          totals.b > 0 ? ((totals.a / totals.b) * 100).toFixed(2) : 0;
      }

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                {
                  label:
                    "Jumlah kematian ibu pada saat melahirkan dan setelah melahirkan",
                },
                { label: "Jumlah keseluruhan ibu melahirkan" },
                { label: "Persentase kematian ibu melahirkan", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah kematian ibu pada saat melahirkan dan setelah melahirkan",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah keseluruhan ibu melahirkan",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Nama Ibu Melahirkan", rowspan: 2, width: "12%" },
                {
                  label: "Tanggal Kejadian",
                  colspan: 2,
                },
                { label: "Penyebab Kematian", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Tanggal Melahirkan" },
                { label: "Lahir Hidup/Meninggal" },
              ],
            ],

            bodyColumns: ["nama", "tanggal", "status", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                {
                  label:
                    "Jumlah balita umur 0 sampai 59 bulan dengan panjang badan atau tinggi badan kurang dari -2 standar deviasi",
                },
                {
                  label:
                    "Jumlah balita umur 0 sampai 59 bulan yang diukur panjang badan atau tinggi badan",
                },
                { label: "Capaian Prevalensi Stunting", width: "8%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah balita umur 0 sampai 59 bulan dengan panjang badan atau tinggi badan kurang dari -2 standar deviasi",
                    type: "number",
                  },
                  {
                    key: "b",
                    label:
                      "Jumlah balita umur 0 sampai 59 bulan yang diukur panjang badan atau tinggi badan",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Fasilitas Kesehatan", rowspan: 2, width: "12%" },
                { label: "Desa / Kelurahan", rowspan: 2, width: "12%" },
                { label: "Jumlah Balita di Ukur", colspan: 3 },
                { label: "Status Gizi PB/U atau TB/U", colspan: 5 },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Total" },
                { label: "Sangat Pendek" },
                { label: "Pendek" },
                { label: "Jumlah Stunting" },
                { label: "% Stunting" },
                { label: "Normal" },
              ],
            ],

            bodyColumns: [
              "fasilitas",
              "desId",
              "a",
              "b",
              "total1",
              "c",
              "d",
              "total2",
              "percentage",
              "normal",
            ],
            sumColumns: ["a", "b", "total1", "c", "d", "total2", "normal"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Jumlah Balita di Ukur",
                cols: 2,
                fields: [
                  { key: "a", label: "Laki-laki", type: "number" },
                  { key: "b", label: "Perempuan", type: "number" },
                ],
              },
              {
                title: "Status Gizi PB/U atau TB/U",
                cols: 2,
                fields: [
                  { key: "c", label: "Sangat Pendek", type: "number" },
                  { key: "d", label: "Pendek", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total1: a + b,
              total2: c + d,
              normal : (a + b) - (c + d),
              percentage: (a + b > 0 ? ((c + d) / (a + b)) * 100 : 0).toFixed(
                2,
              ),
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Puskesmas/Rumah Sakit", width: "12%" },
                {
                  label:
                    "Jumlah Ibu Hamil Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                { label: "Jumlah Sasaran Ibu Bersalin" },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Ibu Hamil Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Sasaran Ibu Bersalin",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Ibu Bersalin Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pesalinan Normal" },
                { label: "Persalinan Komplikasi" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: true,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Ibu Bersalin Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 2,
                fields: [
                  { key: "a", label: "Persalinan Normal", type: "number" },
                  { key: "b", label: "Persalinan Komplikasi", type: "number" },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Sasaran Ibu Bersalin" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Sasaran Ibu Bersalin",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 8
      // =========================
      if (id === 8) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                {
                  label:
                    "Jumlah Bayi Baru Lahir Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                { label: "Jumlah Sasaran Bayi Baru Lahir" },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Bayi Baru Lahir Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Sasaran Bayi Baru Lahir",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 9
      // =========================
      if (id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                {
                  label:
                    "Jumlah Balita Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                { label: "Jumlah Sasaran Balita" },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Balita Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  { key: "b", label: "Jumlah Sasaran Balita", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 10
      // =========================
      if (id === 10) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kec", rowspan: 2, width: "12%" },
                { label: "Rumah Sakit / Puskesmas", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Balita Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 4,
                },
                { label: "Jumlah Sasaran Balita", colspan: 4 },
                { label: "Capaian (%)", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Usia 12-23 Bulan" },
                { label: "Usia 24-35 Bulan" },
                { label: "Usia 36-59 Bulan" },
                { label: "Total" },
                { label: "Usia 12-23 Bulan" },
                { label: "Usia 24-35 Bulan" },
                { label: "Usia 36-59 Bulan" },
                { label: "Total" },
              ],
            ],

            bodyColumns: [
              "fasilitas",
              "a",
              "b",
              "c",
              "total1",
              "d",
              "e",
              "f",
              "total2",
              "percentage",
            ],
            sumColumns: ["a", "b", "total1", "c", "d", "e", "f", "total2"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Balita Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 3,
                fields: [
                  { key: "a", label: "Usia 12-23 Bulan", type: "number" },
                  { key: "b", label: "Usia 24-35 Bulan", type: "number" },
                  { key: "c", label: "Usia 36-59 Bulan", type: "number" },
                ],
              },
              {
                title: "Jumlah Sasaran Balita",
                cols: 3,
                fields: [
                  { key: "d", label: "Usia 12-23 Bulan", type: "number" },
                  { key: "e", label: "Usia 24-35 Bulan", type: "number" },
                  { key: "f", label: "Usia 36-59 Bulan", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              total1: a + b + c,
              total2: d + e + f,
              percentage: (d + e + f > 0
                ? ((a + b + c) / (d + e + f)) * 100
                : 0
              ).toFixed(2),
            };
          },
        };
      }

      // =========================
      // INDIKATOR 11
      // =========================
      if (id === 11) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                {
                  label:
                    "Jumlah Anak Usia Pendidikan Dasar Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                { label: "Jumlah Sasaran Anak Usia Pendidikan Dasar" },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Anak Usia Pendidikan Dasar Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Sasaran Anak Usia Pendidikan Dasar",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 12
      // =========================
      if (id === 12) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kec", rowspan: 2, width: "12%" },
                { label: "Rumah Sakit / Puskesmas", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Anak Usia Pendidikan Dasar Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 3,
                },
                {
                  label: "Jumlah Sasaran Anak Usia Pendidikan Dasar",
                  rowspan: 2,
                  width: "15%",
                },
                { label: "Capaian (%)", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Di sekolah/madrasah/pondok pesantren" },
                { label: "Di panti/LKSA, lapas/LPKA dan Posyandu remaja" },
                { label: "Total" },
              ],
            ],

            bodyColumns: ["fasilitas", "a", "b", "total1", "c", "percentage"],
            sumColumns: ["a", "b", "total1", "c"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Anak Usia Pendidikan Dasar Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Di sekolah/madrasah/pondok pesantren",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Di panti/LKSA, lapas/LPKA dan Posyandu remaja",
                    type: "number",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "c",
                    label: "Jumlah Sasaran Anak Usia Pendidikan Dasar",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);

            return {
              ...row,
              a,
              b,
              c,
              total1: a + b,
              percentage: c > 0 ? (((a + b) / c) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 13
      // =========================
      if (id === 13) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                {
                  label:
                    "Jumlah Warga Negara Usia 15 Tahun s.d 59 Tahun Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                {
                  label:
                    "Jumlah Sasaran Warga Negara Usia 15 Tahun s.d 59 Tahun",
                },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Warga Negara Usia 15 Tahun s.d 59 Tahun Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  {
                    key: "b",
                    label:
                      "Jumlah Sasaran Warga Negara Usia 15 Tahun s.d 59 Tahun",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 14
      // =========================
      if (id === 14) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                {
                  label:
                    "Jumlah Warga Negara Usia 60 Tahun Atau Lebih Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                },
                {
                  label: "Jumlah Sasaran Warga Negara Usia 60 Tahun Atau Lebih",
                },
                { label: "Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Warga Negara Usia 60 Tahun Atau Lebih Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                    type: "number",
                  },
                  {
                    key: "b",
                    label:
                      "Jumlah Sasaran Warga Negara Usia 60 Tahun Atau Lebihs",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 15
      // =========================
      if (id === 15) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Penderita Hipertensi Usia ≥ 15 Tahun Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 4,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pengukuran Tekanan Darah" },
                { label: "Pelayanan Edukasi Non Farmakologi" },
                { label: "Pelayanan Farmakologi" },
                {
                  label:
                    "Konseling Kepatuhan Terapi Non Farmakologi dan Farmakologi",
                },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "f"],
            sumColumns: ["a", "b", "c", "d", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Penderita Hipertensi Usia ≥ 15 Tahun Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Pengukuran Tekanan Darah",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Pelayanan Edukasi Non Farmakologi",
                    type: "number",
                  },
                  { key: "c", label: "Pelayanan Farmakologi", type: "number" },
                  {
                    key: "d",
                    label:
                      "Konseling Kepatuhan Terapi Non Farmakologi dan Farmakologi",
                    type: "number",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "f",
                    label: "Jumlah",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              f,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 16
      // =========================
      if (id === 16) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penduduk Usia ≥ 15 Tahun" },
                { label: "Estimasi Jumlah Penderita Hipertensi" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Penduduk Usia ≥ 15 Tahun",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Estimasi Jumlah Penderita Hipertensi",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 17
      // =========================
      if (id === 17) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Sudah Terlayani/Belum" },
                { label: "Jenis Pelayanan" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["status", "deskripsi"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            return {
              ...row,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 18
      // =========================
      if (id === 18) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Penderita Diabetes Militus (DM) Usia ≥ 15 Tahun Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 4,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pemeriksaan Klinis" },
                { label: "Pemeriksaan Penunjang" },
                { label: "Terapi Non Farmakologi" },
                { label: "Terapi Farmakologi" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "f"],
            sumColumns: ["a", "b", "c", "d", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Penderita Diabetes Melitus (DM) Usia ≥ 15 Tahun Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 2,
                fields: [
                  { key: "a", label: "Pemeriksaan Klinis", type: "number" },
                  { key: "b", label: "Pemeriksaan Penunjang", type: "number" },
                  { key: "c", label: "Terapi Non Farmakologi", type: "number" },
                  { key: "d", label: "Terapi Farmakologi", type: "number" },
                ],
              },
              {
                cols: 1,
                fields: [
                  { key: "f", label: "Jumlah", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              f,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 19
      // =========================
      if (id === 19) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penduduk Usia ≥ 15 Tahun" },
                { label: "Estimasi Jumlah Penderita Diabetes Melitus" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Penduduk Usia ≥ 15 Tahun",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Estimasi Jumlah Penderita Diabetes Melitus",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 20
      // =========================
      if (id === 20) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Sudah Terlayani/Belum" },
                { label: "Jenis Pelayanan" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["status", "deskripsi"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            return {
              ...row,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 21
      // =========================
      if (id === 21) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label:
                    "Penderita ODGJ Berat Yang Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                  colspan: 4,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pemeriksaan kesehatan jiwa" },
                { label: "Tata laksana medis dan nonmedis" },
                { label: "Edukasi" },
                { label: "Pelayanan berkelanjutan" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "f"],
            sumColumns: ["a", "b", "c", "d", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title:
                  "Penderita ODGJ Berat Usia ≥ 15 Tahun Mendapatkan Pelayanan Kesehatan Sesuai Standar",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Pemeriksaan kesehatan jiwa",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Tata laksana medis dan nonmedis",
                    type: "number",
                  },
                  { key: "c", label: "Edukasi", type: "number" },
                  {
                    key: "d",
                    label: "Pelayanan berkelanjutan",
                    type: "number",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "f",
                    label: "Jumlah",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              f,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 22
      // =========================
      if (id === 22) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penderita ODGJ Berat Berdasarkan Proyeksi" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Penderita ODGJ Berat Berdasarkan Proyeksi",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 23
      // =========================
      if (id === 23) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Sudah Terlayani/Belum" },
                { label: "Jenis Pelayanan" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["status", "deskripsi"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            return {
              ...row,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 24
      // =========================
      if (id === 24) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label: "Jumlah Orang Terduga TBC",
                  colspan: 3,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pemeriksaan Klinis Berdasarkan Gejala dan Tanda" },
                { label: "Pemeriksaan Penunjang" },
                { label: "Edukasi" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "f"],
            sumColumns: ["a", "b", "c", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Jumlah Orang Terduga TBC",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Pemeriksaan Klinis Berdasarkan Gejala dan Tanda",
                    type: "number",
                  },
                  { key: "b", label: "Pemeriksaan Penunjang", type: "number" },
                  { key: "c", label: "Edukasi", type: "number" },
                  { key: "f", label: "Jumlah", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              f,
              total: a + b + c,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 25
      // =========================
      if (id === 25) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Perkiraan Orang Yang Terduka Tuberkulosis" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Perkiraan Orang Yang Terduka Tuberkulosis",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 26
      // =========================
      if (id === 26) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Sudah Terlayani/Belum" },
                { label: "Jenis Pelayanan" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["status", "deskripsi"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            return {
              ...row,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 27
      // =========================
      if (id === 27) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label:
                    "Jumlah Orang Dengan Risiko Terinfeksi Hiv (Ibu Hamil, Pasien Ims, Pasien TBC, WPS, LSL, Penasun, WBP, Dan Transgender/Waria) yang Mendapatkan Pelayanan sesuai Standar",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [{ label: "Edukasi Perilaku Berisiko" }, { label: "Skrining" }],
            ],

            bodyColumns: ["a", "b", "f"],
            sumColumns: ["a", "b", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Orang Dengan Risiko Terinfeksi Hiv (Ibu Hamil, Pasien Ims, Pasien TBC, WPS, LSL, Penasun, WBP, Dan Transgender/Waria) yang Mendapatkan Pelayanan sesuai Standar",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Edukasi Perilaku Berisiko",
                    type: "number",
                  },
                  { key: "b", label: "Skrining", type: "number" },
                ],
              },
              {
                cols: 1,
                fields: [
                  { key: "f", label: "Jumlah", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              f,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 28
      // =========================
      if (id === 28) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                {
                  label:
                    "Jumlah Orang Dengan Risiko Terinfeksi Hiv (Ibu Hamil, Pasien Ims, Pasien TBC, WPS, LSL, Penasun, WBP, Dan Transgender/Waria)",
                  width: "30%",
                },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Orang Dengan Risiko Terinfeksi Hiv (Ibu Hamil, Pasien Ims, Pasien TBC, WPS, LSL, Penasun, WBP, Dan Transgender/Waria)",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 29
      // =========================
      if (id === 29) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Jumlah Orang Dengan Resiko HIV", width: "12%" },
                {
                  label: "Jumlah Orang Dengan Resiko HIV Yang Terlayani",
                  width: "12%",
                },
                { label: "Proporsi Orang Yang Terlayani", width: "12%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Orang Dengan Resiko HIV",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Orang Dengan Resiko HIV Yang Terlayani",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: a > 0 ? ((b / a) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 30
      // =========================
      if (id === 30) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Rumah Sakit / Puskesmas", width: "12%" },
                { label: "Kelompok Resiko", width: "12%" },
                { label: "Sudah Terlayani/Belum" },
                { label: "Jenis Pelayanan" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["fasilitas", "nama", "status", "deskripsi"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            return {
              ...row,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DINKES + "viewSehat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "dinkesSehat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DINKES + "indikator_sehat", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Kesehatan</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DINKES + "addSehat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DINKES + "editSehat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DINKES + "removeSehat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.e = data.e;
      this.form.f = data.f;
      this.form.tanggal = data.tanggal;
      this.form.status = data.status;
      this.form.deskripsi = data.deskripsi;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
